import { defineMessages } from 'react-intl';

export const communityMessages = defineMessages({
  defaultSpecialty: {
    defaultMessage: 'Medical',
    id: 'WYAiBY1/1p',
    description: 'Fallback specialty used in community template page metadata',
  },
  clearSearch: {
    defaultMessage: 'Clear search',
    id: 'rp714TXHFG',
    description:
      'Accessible label for the clear-search button in the template community search bar',
  },
  pageTitle: {
    defaultMessage: '{specialty} Templates | Heidi Health | Free AI Medical Scribe',
    id: 'geA2f8oniW',
    description: 'Browser tab title for the community template gallery',
  },
  metaDescription: {
    defaultMessage:
      '{specialty} template. This template helps streamline the documentation process, ensuring no critical information is missed during the initial assessment. Heidi Health, the AI medical scribe for all specialties',
    id: 'Z9plVI6kD8',
    description: 'SEO description for the community template gallery',
  },
  logoAlt: {
    defaultMessage: 'Heidi logo',
    id: '0V6AmVjzzg',
    description: 'Alternative text for the Heidi logo on the community template gallery',
  },
  searchPlaceholder: {
    defaultMessage: 'Search for a template',
    id: 'JNoxs7XI1+',
    description: 'Placeholder for the community template search input',
  },
  myTemplates: {
    defaultMessage: 'My templates',
    id: '+PhKGFkmaF',
    description: 'Back button label linking to the user’s template library',
  },
  heading: {
    defaultMessage: 'Template Community',
    id: 'b0LXDuVOmc',
    description: 'Heading for the community template gallery',
  },
  viewAllResults: {
    defaultMessage: 'View all results',
    id: '4BzzepVgjp',
    description: 'Button that clears restrictive filters to show all templates',
  },
});
